import { Box, Button, ButtonProps, Typography } from '@mui/material';
import { SelectQualificationHeader } from './QualificationFormHeader';

interface StudentQualificationSelectOptionProps {
  PrimaryButtonProps?: ButtonProps;
  SecondaryButtonProps?: ButtonProps;
  PrimaryButtonLabel: string;
  SecondaryButtonLabel: string;
  TertiaryButtonProps?: ButtonProps;
  TertiaryButtonLabel?: string;
}
export const StudentQualificationSelectOption: React.FC<StudentQualificationSelectOptionProps> = ({
  PrimaryButtonLabel,
  PrimaryButtonProps,
  SecondaryButtonLabel,
  SecondaryButtonProps,
  TertiaryButtonLabel,
  TertiaryButtonProps,
}) => {
  return (
    <Box sx={{ px: 2.5 }}>
      <SelectQualificationHeader />
      <Button sx={{ mb: 2, width: 1 }} {...PrimaryButtonProps} variant="contained">
        {PrimaryButtonLabel}
      </Button>
      <Button sx={{ width: 1 }} {...SecondaryButtonProps} variant="light">
        {SecondaryButtonLabel}
      </Button>
      {TertiaryButtonLabel && (
        <Button sx={{ width: 1, mt: 2 }} {...TertiaryButtonProps} variant="default">
          {TertiaryButtonLabel}
        </Button>
      )}
      <Box sx={{ mt: 3 }}>
        <Typography color="secondary" variant="small" fontWeight="Bold">
          Important Information
        </Typography>
        <Box component="ol" sx={{ listStylePosition: 'inside', mt: 1, color: 'secondary.main' }}>
          <Box component="li" sx={{ mb: 1.5 }}>
            <Typography variant="medium" color="secondary">
              Education details would help you find eligible programs and scholarships and you would be eligible to
              apply on them.
            </Typography>
          </Box>
          <Box component="li">
            <Typography variant="medium" color="secondary">
              Eligibility qualification would help you find eligible programs and scholarships but you would need to
              create education details that match your eligibility qualification before apply.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
